import { Component, type ErrorInfo, type ReactNode } from 'react';

import { ErrorState } from './error-state';

export class ErrorBoundary extends Component<{ children: ReactNode }, { failed: boolean }> {
  override state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  override componentDidCatch(error: Error, info: ErrorInfo) {
    if (import.meta.env.DEV) console.error(error, info);
  }

  override render() {
    if (this.state.failed) {
      return (
        <div className="flex min-h-screen items-center justify-center p-6">
          <ErrorState
            message="Não foi possível exibir esta tela. Código: UI-001. Informe ao suporte a tela e o horário; antes de repetir uma gravação, confira seu histórico."
            onRetry={() => window.location.reload()}
          />
        </div>
      );
    }
    return this.props.children;
  }
}
